/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataToJSON, } from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData';
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData(json)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData(value)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin.js.map